import React from "react";
import striptags from "striptags";

const ServiceHero = ({ data }) => {
  return (
    <section className="service-hero-section light-primary-background">
      <div className="service-hero-inner">
        <div className="container">
          <div className="row">
            <div className="col-lg-10">
              {data?.map((val, i) => {
                const titleWithoutPTag = val?.value?.title;
                if (val?.type == "service_list_banner") {
                  return (
                    <div className="heading" key={i}>
                      <div>
                        <span
                          className="heading-h1"
                          itemProp="heading"
                          dangerouslySetInnerHTML={{
                            __html: titleWithoutPTag,
                          }}
                        ></span>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: val?.value?.description,
                        }}
                      ></div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
